import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent } from "../../utils";
import { selectAnswerData, selectAnswerStatus, selectAnswerError, initializeAsync } from "./answerSlice";

import { useAuth } from "../../hooks/useAuth";
import { Logo } from "../../components/Logo";
import { Button, CssBaseline, TextField, Box, Typography, Container, Paper, Snackbar, Alert } from "@mui/material";

import LoadingButton from "@mui/lab/LoadingButton";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import "./style.css";
import { SimpleHeader } from "../../components/SimpleHeader";

const Answer = () => {
    const data = useSelector(selectAnswerData);
    const status = useSelector(selectAnswerStatus);
    const error = useSelector(selectAnswerError);
    const dispatch = useDispatch();
    const { answer, user, passwordLessLogin } = useAuth();
    const [openToster, setOpenToster] = useState(false);
    const [tosterVariant, setTosterVariant] = useState("error");
    const [tosterMessage, setTosterMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [displayBox, setDisplayBox] = useState(false);

    React.useEffect(() => {
        setTimeout(() => {
            setDisplayBox(true);
        }, 1500);
    }, []);
    useEffect(() => {
        if (status === "idle") {
            dispatch(initializeAsync());
        }
    }, [status, dispatch]);

    const handleTosterClose = () => {
        setOpenToster(false);
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const data = new FormData(event.currentTarget);
        if (data.get("otp")) {
            setLoading(true);
            answer(user, data.get("otp"), (message) => {
                message = message ? message : "Invalid otp";
                if (message) {
                    setTosterVariant("error");
                    setTosterMessage(message);
                    setOpenToster(true);
                }
                setLoading(false);
            });
        }
    };

    const handleResend = () => {
        passwordLessLogin({
            email: user.username,
            callback: (failed) => {
                if (failed) {
                    setTosterVariant("error");
                    setTosterMessage(`Sorry, we don't recognize this email address.`);
                    setOpenToster(true);
                } else {
                    setTosterVariant("success");
                    setTosterMessage(`Successfully resend the one-time passcode.`);
                    setOpenToster(true);
                }
                setLoading(false);
            },
        });
    };

    let body = (
        <Box
            component="main"
            sx={{
                position: "absolute",
                width: "100%",
                height: "100%",
                backgroundColor: "black",
            }}>
            <SimpleHeader></SimpleHeader>
            <Box
                sx={{
                    alignItems: "center",
                    display: "flex",
                    flexGrow: 1,
                    minHeight: "100%",
                    backgroundColor: "black",
                }}>
                <Container
                    className={displayBox ? "fade-in show" : "fade-in"}
                    maxWidth="sm"
                    sx={{ maxWidth: "450px !important", justifyContent: "center", mt: "-6rem" }}>
                    <CssBaseline />
                    <Paper
                        elevation={16}
                        sx={{
                            backgroundColor: "rgb(255, 255, 255)",
                            color: "rgb(18, 24, 40)",
                            transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                            borderRadius: "0px",
                            boxShadow: "rgb(100 116 139 / 12%) 0px 10px 15px",
                            backgroundImage: "none",
                            overflow: "hidden",
                            padding: "32px",
                        }}>
                        <Box sx={{ textAlign: "center" }}>
                            <Typography component="h1" variant="h4">
                                Check your email!
                            </Typography>
                            <Typography
                                align="center"
                                color="textSecondary"
                                variant="subtitle1"
                                margin="1rem"
                                fontSize="0.875rem"
                                sx={{ fontWeight: "400", lineHeight: "20px" }}>
                                We've sent a one-time passcode to your email to confirm your identity. Enter it below to
                                log in.
                            </Typography>
                        </Box>
                        <Box component="form" onSubmit={handleSubmit} validate sx={{ mt: 1 }}>
                            <TextField
                                type="text"
                                margin="normal"
                                fullWidth
                                id="otp"
                                label="One-time Passcode"
                                name="otp"
                                autoFocus
                                sx={{ borderRadius: "8px" }}
                                variant="outlined"
                                min={0}
                            />

                            <LoadingButton
                                size="small"
                                type="submit"
                                color="dark"
                                fullWidth
                                loading={loading}
                                loadingPosition="end"
                                variant="contained"
                                sx={{ mt: 3, mb: 2, height: "45px", backgroundColor: "#000" }}>
                                Submit
                            </LoadingButton>

                            <Typography
                                align="center"
                                color="textSecondary"
                                variant="subtitle1"
                                margin="1rem"
                                fontSize="0.675rem"
                                sx={{ fontWeight: "400", lineHeight: "20px" }}>
                                This one-time passcode is valid for the next 2 minutes. If you need a new code, please
                                click{" "}
                                <a style={{ cursor: "pointer" }} onClick={handleResend}>
                                    here
                                </a>{" "}
                                to receive a new code to the email address entered
                            </Typography>
                        </Box>
                    </Paper>
                    <Grid container sx={{ marginTop: "-2rem", width: "100%" }}>
                        <Grid item xs={4} sx={{ height: "10px", background: "white" }}></Grid>
                        <Grid item xs={4} sx={{ height: "30px", background: "white" }}></Grid>
                        <Grid item xs={4} sx={{ height: "50px", background: "white" }}></Grid>
                    </Grid>
                </Container>
            </Box>

            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={openToster}
                autoHideDuration={6000}
                onClose={handleTosterClose}>
                <Alert onClose={handleTosterClose} severity={tosterVariant} variant="filled">
                    {tosterMessage}
                </Alert>
            </Snackbar>
        </Box>
    );

    return getPageContent(body, status, error);
};

export { Answer };
